export const Rating = ({ children, rateOf10, showRating = true, maxValue = 10, onBlur, ocRatechange, retedcolor, notRatedColor }) => {
    return <>
        <label onBlur={onBlur}
            contenteditable="true" className={(showRating ? 'w-50' :'w-100')+` py-2 px-1 pe-3  text-end`}
        >{children}</label>
        {showRating &&
            <div style={{ display: 'inline-flex', borderRadius: (maxValue - 6) + 'px', overflow: 'hidden' }}>
                {Array.from({ length: maxValue }, (v, k) => k + 1).map(r =>
                    <div onClick={(e) => ocRatechange(e, r)} key={r} title={r} 
                        style={{ marginRight: (10 - maxValue) + 'px', border: '0', width: '12px', height: '18px', color: 'white', fontSize: '12px', background: (rateOf10 >= r ? retedcolor || '#07a107' : notRatedColor || '#bfbfbf'), position: 'relative' }}>
                        <span style={{ marginTop: '-2px', position: 'absolute' }}>{rateOf10 == r ? r : ' '}</span>
                    </div>
                )}
            </div>
        }
    </>
}




